// Maxin to handle a common local state in pages which have tabs

export default {
  data() {
    return {
      tabIndex: 0,
    };
  },

  methods: {
    setTabIndex(index) {
      // TODO implement "transform: translate(-50%,0);" to create a slide animation
      this.tabIndex = index;
    },
  },
};
